import { trackEvent } from 'modules/analytics';

const BASE_ATTRIBUTES = { location: 'riverside_existing_user' };

const trackExistingUserPodcastConfirmationScreenViewed = () => {
  trackEvent('screen_viewed', BASE_ATTRIBUTES, {
    providers: [mParticle],
  });
};

const trackExistingUserPodcastConfirmationClicked = () => {
  trackEvent('riverside_existing_confirm_podcast', BASE_ATTRIBUTES, {
    providers: [mParticle],
  });
};

const trackExistingUserPodcastSignupClicked = () => {
  trackEvent('riverside_existing_signup', BASE_ATTRIBUTES, {
    providers: [mParticle],
  });
};

const trackExistingUserPodcastLoginClicked = () => {
  trackEvent('riverside_existing_log_in', BASE_ATTRIBUTES, {
    providers: [mParticle],
  });
};

const trackExistingUserPodcastSwitchClicked = () => {
  trackEvent('riverside_existing_switch', BASE_ATTRIBUTES, {
    providers: [mParticle],
  });
};

export {
  trackExistingUserPodcastConfirmationScreenViewed,
  trackExistingUserPodcastConfirmationClicked,
  trackExistingUserPodcastSignupClicked,
  trackExistingUserPodcastLoginClicked,
  trackExistingUserPodcastSwitchClicked,
};
